import apiClient from '@/api/client';

// ─── Mitteilungen, Abstimmungen, Vorschläge ──────────────────────────────────
//
// Drei Dinge, die dem KONTO gelten und nicht einem Stammbaum: was der
// Betreiber mitzuteilen hat, was er fragt, und was man ihm zurückschicken
// kann.

export interface Mitteilung {
  id: string;
  titel: string;
  text: string;
  art: string;
  createdAt: string;
}

export interface UmfrageOption {
  id: string;
  text: string;
  stimmen: number;
}

export interface Umfrage {
  id: string;
  frage: string;
  text: string | null;
  status: string;
  laeuftBis: string | null;
  abgestimmt: boolean;
  optionen: UmfrageOption[];
  gesamt: number;
}

/** Alles fürs Popup in einer Anfrage – zwei wären zwei Gelegenheiten zu spät. */
export async function ladeAnliegen(): Promise<{
  mitteilungen: Mitteilung[];
  umfragen: Umfrage[];
}> {
  const { data } = await apiClient.get<{ mitteilungen: Mitteilung[]; umfragen: Umfrage[] }>(
    '/anliegen',
  );
  return data;
}

export async function mitteilungGesehen(id: string): Promise<void> {
  await apiClient.post(`/anliegen/mitteilungen/${id}/gesehen`);
}

export async function ladeUmfragen(): Promise<Umfrage[]> {
  const { data } = await apiClient.get<{ data: Umfrage[] }>('/anliegen/umfragen');
  return data.data;
}

export async function stimmeAb(umfrageId: string, optionId: string): Promise<Umfrage | null> {
  const { data } = await apiClient.post<{ umfrage: Umfrage | null }>(
    `/anliegen/umfragen/${umfrageId}/stimme`,
    { optionId },
  );
  return data.umfrage;
}

export interface Vorschlag {
  id: string;
  art: string;
  titel: string;
  text: string;
  status: string;
  antwort: string | null;
  createdAt: string;
}

export interface VorschlagEingabe {
  art: 'idee' | 'fehler';
  titel: string;
  text: string;
  seite?: string;
  browser?: string;
}

export async function reicheVorschlagEin(eingabe: VorschlagEingabe): Promise<Vorschlag> {
  const { data } = await apiClient.post<Vorschlag>('/anliegen/vorschlaege', eingabe);
  return data;
}

export async function ladeEigeneVorschlaege(): Promise<Vorschlag[]> {
  const { data } = await apiClient.get<{ data: Vorschlag[] }>('/anliegen/vorschlaege');
  return data.data;
}
